import React, { useState, useCallback } from 'react';
import { FontWeight, Size } from '../../../styles/theme.mjs';
import LocationIcon from '../../Basic/Icons/LocationIcon.mjs';
import Heading from '../../Typography/Heading/Heading.mjs';
import TextComponent from '../../Typography/Text/Text.mjs';
import RegionSelectionModal from '../RegionSelectionModal/RegionSelectionModal.mjs';
import { StyledRegionSelector, StyledLocation, StyledButton } from './RegionSelector.styles.mjs';
import { useTheme } from 'styled-components';

const RegionSelector = ({ selectedRegion, onSelect, regionSelectionModalProps }) => {
    const theme = useTheme();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const toggleModalOpen = () => setIsModalOpen((prevOpen) => !prevOpen);
    const handleRegionSelect = useCallback((region) => {
        onSelect(region);
        setIsModalOpen(false);
    }, [onSelect]);
    return (React.createElement(StyledRegionSelector, null,
        React.createElement(StyledLocation, null,
            React.createElement(LocationIcon, null),
            React.createElement(TextComponent, { tag: "span", size: Size.Medium, fontWeight: FontWeight.Medium }, selectedRegion.name)),
        React.createElement(StyledButton, { "aria-label": "Select region", onClick: toggleModalOpen },
            React.createElement(Heading, { tag: "h6", color: theme.colors.mutedTextColor }, "Change")),
        React.createElement(RegionSelectionModal, Object.assign({ isOpen: isModalOpen, selectedRegion: selectedRegion, onClose: toggleModalOpen, onRegionSelect: handleRegionSelect }, regionSelectionModalProps))));
};

export { RegionSelector as default };
//# sourceMappingURL=RegionSelector.mjs.map
